import { default as videojs } from 'video.js';
import { MediaItem, StreamingMediaSource, TextTrack, TextTrackKind } from '../../models';
import { MimeTypeProvider } from '../../utils';
import { SourceMimeTypes } from './enums';

export class PlaylistMapper {

    static mapMediaItem(item: MediaItem): videojs.Tech.SourceObject[] {
        return item.sources.map((source: StreamingMediaSource) => {
            return PlaylistMapper.mapSource(source, item);
        });
    }

    static mapSource(source: StreamingMediaSource, item: MediaItem): videojs.Tech.SourceObject {
        const mime: SourceMimeTypes = MimeTypeProvider.getMimeType(source);
        const vjs_source: videojs.Tech.SourceObject = {src: source.file};
        if (mime) {
            vjs_source.type = mime;
        }

        (<MediaItem>vjs_source).withCredentials = item.withCredentials === true;
        (<MediaItem>vjs_source).limitRenditionByPlayerDimensions = item.limitRenditionByPlayerDimensions;

        return vjs_source;
    }

    static mapVideoTextTracks(tracks: TextTrack[]): videojs.TextTrackOptions[] {
        return tracks.map((track: TextTrack) => {
            const kind: videojs.TextTrack.Kind = track.kind as videojs.TextTrack.Kind;
            let mode: TextTrackMode;

            switch (track.kind) {
                case TextTrackKind.Captions:
                case TextTrackKind.Description:
                    mode = 'showing';
                    break;
                case TextTrackKind.Chapters:
                case TextTrackKind.Thumbnails:
                case TextTrackKind.Metadata:
                    mode = 'hidden';
                    mode = 'hidden';
                    break;
            }

            const textTrackOptions: videojs.TextTrackOptions = {
                default: track.default === true,
                kind: kind,
                mode: mode,
                src: track.src,
            };

            if (track.label) {
                textTrackOptions.label = track.label;
            }

            if (track.language) {
                textTrackOptions.language = track.language;
            }

            return textTrackOptions;
        });

    }
}
